import { NumberFormatBase } from 'react-number-format';
import { Flex, Input, Text, useRecipe } from '@chakra-ui/react';

import { InputGroup } from '../../../lib/chakraUi/components';
import { FormFieldControlledComponent } from '../../../types';
import { usePhone } from './hooks/usePhone';
import { PhoneInputProps } from './types/PhoneInputProps';
import { PhoneProps } from './types/PhoneProps';
import { PhoneCountrySelectOrDisplay } from './PhoneCountrySelectOrDisplay';

export const Phone: FormFieldControlledComponent<string, PhoneProps> = ({
  _ref,
  onChange,
  value,
  hooks,
  endElement,
  startElement,
  ...props
}: PhoneInputProps) => {
  const {
    countryCallingCode,
    onCountryChange,
    onNumberChange,
    onNumberKeyDown,
    onNumberPaste,
    nationalNumber,
    format,
  } = usePhone(value, hooks, onChange, props.name);
  const recipe = useRecipe({ key: 'input' });
  const [variantProps] = recipe.splitVariantProps(props as PhoneProps);
  const styles = recipe(variantProps);

  return (
    <InputGroup endElement={endElement} startElement={startElement}>
      <Flex
        alignItems="center"
        className="input-like"
        css={styles}
        gap={2}
        p={0}
        w="full"
      >
        <PhoneCountrySelectOrDisplay
          countryCallingCode={countryCallingCode}
          hasStartElement={!!startElement}
          onChange={onCountryChange}
        />
        <Flex alignItems="center" flexGrow={1} gap={1}>
          <Text color="fg.subtle">(0)</Text>
          <Input
            ref={_ref}
            asChild
            id={props.name}
            onChange={onNumberChange}
            onKeyDown={onNumberKeyDown}
            onPaste={onNumberPaste}
            type="tel"
            value={nationalNumber}
            {...props}
            bg="transparent"
            border="none"
          >
            <NumberFormatBase format={format} />
          </Input>
        </Flex>
      </Flex>
    </InputGroup>
  );
};

Phone.controlled = true;
Phone.displayName = 'Phone';
